import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y, filter: "blur(6px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1.15, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHead = ({ index, overline, title, className = "" }) => (
  <div className={`mb-12 md:mb-16 ${className}`}>
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        {index && (
          <span className="font-display text-gold text-sm font-bold tracking-[0.3em]">{index}</span>
        )}
        <span className="h-px w-16 bg-gold/60" aria-hidden="true" />
        <span className="text-xs uppercase tracking-[0.25em] text-white/60">{overline}</span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.02] text-ivory">
        {title}
      </h2>
    </Reveal>
  </div>
);

export const GoldButton = ({ children, className = "", ...props }) => (
  <button
    className={`group relative inline-flex items-center gap-3 bg-gold px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.15em] text-obsidian transition-colors duration-300 hover:bg-gold-light ${className}`}
    {...props}
  >
    {children}
  </button>
);

export const GhostLink = ({ children, className = "", ...props }) => (
  <a
    className={`group inline-flex items-center gap-3 border border-white/20 px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.15em] text-ivory transition-colors duration-300 hover:border-gold hover:text-gold ${className}`}
    {...props}
  >
    {children}
  </a>
);
